import { EventLogQueueContext } from "contexts/EventLogQueueProvider";
import React from "react";

export const useEventLogQueue = (): React.ContextType<typeof EventLogQueueContext> =>
  React.useContext(EventLogQueueContext);
